"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAmount = exports.calculateMontoSolicitado = exports.calculatePagoMensual = void 0;
function calculatePagoMensual(pagoTotal, primaTotal, plazo) {
    return pagoTotal + primaTotal / plazo;
}
exports.calculatePagoMensual = calculatePagoMensual;
function calculateMontoSolicitado(price, enganche) {
    return price - enganche;
}
exports.calculateMontoSolicitado = calculateMontoSolicitado;
function calculateAmount(percentage, priceCar) {
    return (percentage * priceCar) / 100;
}
exports.calculateAmount = calculateAmount;
